import { useMutation } from '@tanstack/react-query';
import { SelfServiceSessionService } from '../../generated';
import { SelfServiceInstruction } from './types';

interface DataForNextInstructionProps {
  jobsiteId: string;
  sessionId: string;
  lang: string;
  currentInstruction: SelfServiceInstruction;
}

function withoutServerErrors(instruction: SelfServiceInstruction): SelfServiceInstruction {
  const stripped = structuredClone(instruction);

  if (stripped.component === 'form') {
    stripped.parameters.fields.forEach((field) => delete field.error);
  } else if (stripped.component === 'task') {
    delete stripped.parameters.error;
  }

  return stripped;
}

export function useRequestNextInstruction() {
  return useMutation({
    mutationFn: async ({ jobsiteId, sessionId, lang, currentInstruction }: DataForNextInstructionProps) => {
      const response = await SelfServiceSessionService.selfServiceSessionControllerRequestNextInstruction({
        path: {
          jobsiteId,
          sessionId,
          instructionId: currentInstruction.instructionId,
          lang,
        },
        body: withoutServerErrors(currentInstruction),
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (
          (response as any).error ||
          new Error(response?.response?.statusText || 'Unknown error when requesting initial instruction')
        );
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });
}
